import React from 'react';
import './Introduction.css';
import PixelPortrait from '../PixelPortrait/PixelPortrait';

function Introduction({ title, description }) {
  return (
    <section id="hero" className="hero-section">
      <div className="hero-text">
        <p className="hero-greeting">hola, soy</p>
        <div className="hero-name-row">
          <h1 className="hero-name">{title}</h1>
          <span className="terminal-cursor" aria-hidden="true" />
        </div>
        <h2 className="hero-tagline">{description}</h2>
        <p className="hero-body">
          Arquitecto de datos especializado en AWS y Azure. Creador de contenido en{' '}
          <a href="https://www.instagram.com/r2d2.coder/" target="_blank" rel="noreferrer">
            @r2d2.coder
          </a>{' '}
          donde enseño programación de forma práctica y accesible.
        </p>
        <a
          href="https://mail.google.com/mail/?view=cm&fs=1&to=r2d2techcontact@gmail.com&su=Hola%20Arturo!"
          target="_blank"
          rel="noreferrer"
          className="btn-cta"
        >
          ✉ Say hi!
        </a>
      </div>
      <div className="hero-portrait">
        <PixelPortrait />
      </div>
    </section>
  );
}

export default Introduction;
